module.exports = __webpack_public_path__ + "static/media/contact-decoration.5f092eb6.png";